<div class="rectangle-container">
    <div class="rows-flex">
        <div class="rx-card-title rx-app-flex rx-app-flex-container-row rx-app-flex-container-row--wrap">
            <div class="general-info">{{ 'PrintRx.GeneralInfo' | translate }}</div>
        </div>
        <div class="flex-body">
            <div class="rx-app-flex rx-app-flex-container-column">
                <rx-info-block
                    class="info-box rx-app-flex rx-app-flex-container-column"
                    [fields]="[
            { name: 'DoctorSection.Doctor', id: 'general-doctor-name', value: doctorName$ | async },
            { name: 'PatientSection.Patient', id: 'general-patient-name', value: patientName$ | async },
            { name: 'Lab.LabName', id: 'general-lab-name', value: sendToLab$ | async }
                ]"
                ></rx-info-block>
            </div>
            <div class="separator"></div>
            <div class="rx-app-flex rx-app-flex-container-column">
                <rx-info-block
                    class="info-box rx-app-flex rx-app-flex-container-column"
                    [fields]="[
            {name: 'GeneralRxData.CaseType', id: 'general-case-type', value: caseType$ | async},
            {name: 'GeneralRxData.ChartNumber', id: 'general-chart-number', value: chartNumber$ | async}
                ]"
                ></rx-info-block>
            </div>
            <div class="separator"></div>
            <div class="rx-app-flex rx-app-flex-container-column">
                <rx-info-block
                    class="info-box rx-app-flex rx-app-flex-container-column"
                    [fields]="[
            {
              name: 'GeneralRxData.ScanDate',
              id: 'general-scan-date',
              value: scanDate$ | async | date: (dateFormat$ | async)
            },
            {
              name: 'GeneralRxData.DueDate',
              id: 'general-due-date',
              value: dueDate$ | async | date: (dateFormat$ | async):'UTC'
            },
            { 
                name: 'GeneralRxData.Status', 
                id: 'general-status',
                value: state$ | async 
            }
                ]"
                ></rx-info-block>
            </div>
            <div class="separator"></div>
            <div class="rx-app-flex rx-app-flex-container-column">
                <rx-info-block
                    class="info-box rx-app-flex rx-app-flex-container-column"
                    [fields]="[
            {
              name: 'GeneralRxData.Signature',
              id: 'general-signature',
              value: signature$ | async,
              isSignature: true
            },
            { name: 'GeneralRxData.License', id: 'general-license', value: license$ | async }
                ]"
                ></rx-info-block>
            </div>
        </div>

        <div class="general-info-footer rx-app-flex rx-app-flex-container-row rx-app-flex-container-row--wrap">
            <tlk-checkbox
                class="pre-treatment-checkbox"
                [isDisabled]="true"
                [checked]="preTreatmentScan$ | async"
                name="preTreatmentScan"
            >
                {{ 'GeneralRxData.PreTreatmentScan' | translate }}
            </tlk-checkbox>
        </div>
    </div>
</div>
